import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import MainLayout from "../layout/mainlayout";
import Organizations from "../components/Organizations";
import OrganizationsSummary from "../components/Organizations/organizationsSummary";
import Users from "../components/Users";
import AddUsers from "../components/Users/addUser";
import Community from "../components/Community";
import InnerCircle from "../components/InnerCircle";
import Entertainment from "../components/InnerCircle/entertainment";
import SuggestedActivities from "../components/InnerCircle/suggestedActivities";
import PostSuggestions from "../components/InnerCircle/postSuggestions ";
import EncouragementGroups from "../components/EncouragementGroups";
import GratitudeAttitude from "../components/EncouragementGroups/gratitudeAttitude";
import Notifications from "../components/Notifications";
import ManagePros from "../components/ManagePros";
import ProfileDetail from "../components/ProfileDetail";
import DirectCare from "../components/DirectCare";
import Reports from "../components/Reports";
import PostReport from "../components/Reports/postReport";
import DirectCareReport from "../components/Reports/directCareReport";
import InnerCircleReport from "../components/Reports/innerCircleReport";
import UsersReport from "../components/Reports/userReport";
import Settings from "../components/Settings";
import Messages from "../components/Messages";
import Tools from "../components/ToolsAndResources/tools";
import LogMood from "../components/ToolsAndResources/logmood";
import LogThought from "../components/ToolsAndResources/logThought";
import Meditation from "../components/ToolsAndResources/meditation";
import Playlists from "../components/ToolsAndResources/playlists";
import Resources from "../components/ToolsAndResources/resources";
import Login from "../components/auth/login";
import ForgotPassword from "../components/auth/forgot-password";
import Instruction from "../components/auth/Instruction";
import Protected, { PublicRoute } from "./privateRoute";
import NewPassword from "../components/auth/new-password";
import PasswordCreated from "../components/auth/password-created";
import FeedInnerCircle from "../components/myinnerCircle/FeedInnerCircle";
import PrivacyPolicy from "../components/Privacy/Privacy";
import Terms from "../components/Terms/Term";
import ChangePassword from "../components/auth/ChangePassword";
import DeletePolicy from "../components/Privacy/DeleInstruction";
import Engagementfarming from "../components/EngagementFarming";
import Post from "../components/EngagementFarming/Post";
import CreatePost from "../components/EngagementFarming/CreatePost";
import CreateUser from "../components/EngagementFarming/CreateUser";
import PrivacyPolicyPro from "../components/Privacy/PrivacyPro";
import TermsPro from "../components/Terms/TermsPro";
import SubscriptionScreen from "../components/SubscriptionnScreen";
import PaymentScreen from "../components/SubscriptionnScreen/paymentSummary";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import UserLogin from "../components/auth/user-login";
import { setReferral } from "../redux/slices/referralSlice.slice";
import { useDispatch, useSelector } from "react-redux";
import CreateUserPassword from "../components/auth/createUserPassword";
import OtpScreen from "../components/auth/otp";
import PaymentSuccessScreen from "../components/SubscriptionnScreen/Success";

const RoutesNew = () => {
  // const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_TEST_KEY);

  return (
    <div>
      {/* <Router> */}
      <Routes>
        {/* <Route element={<PublicRoute />}> */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        {/* <Route path="/termsandcondition" element={<PublicRoute><Terms /></PublicRoute>} /> */}
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/privacypolicypro" element={<PrivacyPolicyPro />} />
        <Route path="/delete" element={<DeletePolicy />} />
        <Route path="/termsandcondition" element={<Terms />} />
        <Route path="/termsandconditionpro" element={<TermsPro />} />
        <Route path="/changePassword" element={<ChangePassword />} />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/instruction-sent"
          element={
            <PublicRoute>
              <Instruction />
            </PublicRoute>
          }
        />
        <Route
          path="/passwordcreated"
          element={
            <PublicRoute>
              <PasswordCreated />
            </PublicRoute>
          }
        />

        <Route
          path="/"
          element={
            <Navigate
              to={localStorage.getItem("token") ? "organizations" : "login"}
            />
          }
        />

        <Route path="/subscriptionScreen" element={<SubscriptionScreen />} />
        <Route path="/paymentSummary" element={<PaymentScreen />} />
        <Route
          path="/paymentSuccessScreen"
          element={<PaymentSuccessScreen />}
        />
        <Route path="/" element={<MainLayout />}>
          <Route element={<Protected />}>
            <Route path="/organizations" element={<Organizations />} />
            <Route
              path="/organizationssummary"
              element={<OrganizationsSummary />}
            />
            <Route path="/users" element={<Users />} />
            <Route path="/addusers" element={<AddUsers />} />
            <Route path="/community" element={<Community />} />
            <Route path="/innercircle" element={<InnerCircle />} />
            <Route path="/entertainment" element={<Entertainment />} />

            <Route
              path="/suggestedactivities"
              element={<SuggestedActivities />}
            />
            <Route path="/postsuggestions" element={<PostSuggestions />} />
            <Route
              path="/encouragementgroups"
              element={<EncouragementGroups />}
            />
            <Route path="/gratitudeattitude" element={<GratitudeAttitude />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/managepros" element={<ManagePros />} />
            <Route path="/profiledetail/:proId" element={<ProfileDetail />} />
            <Route path="/directcare" element={<DirectCare />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/postreport" element={<PostReport />} />
            <Route path="/directcarereport" element={<DirectCareReport />} />
            <Route path="/innercirclereport" element={<InnerCircleReport />} />
            <Route path="/usersreport" element={<UsersReport />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/tools" element={<Tools />} />
            <Route path="/logmood" element={<LogMood />} />
            <Route path="/logthought" element={<LogThought />} />
            <Route path="/meditation" element={<Meditation />} />
            <Route path="/playlists" element={<Playlists />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/innercircletabs" element={<FeedInnerCircle />} />
            <Route path="/ManagePros" element={<ManagePros />} />
            <Route path="/Engagementfarming" element={<Engagementfarming />} />
            <Route path="/post" element={<Post />} />
            <Route path="/createpost" element={<CreatePost />} />
            <Route path="/createUser" element={<CreateUser />} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
};
export default RoutesNew;
